var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.04 2.89a2.49 2.49 0 0 1 2.164 1.26l7.555 13.223a2.49 2.49 0 0 1 .002 2.488 2.49 2.49 0 0 1-2.154 1.246H4.49a2.488 2.488 0 0 1-2.173-3.734h.001L9.874 4.15a2.49 2.49 0 0 1 2.165-1.26m0 1.2a1.29 1.29 0 0 0-1.123.654l-.001.002-7.557 13.225-.002.003a1.29 1.29 0 0 0 .48 1.765c.198.113.422.17.65.168h15.119l.167-.01a1.292 1.292 0 0 0 .948-1.923l-.001-.003-7.558-13.225v-.002a1.29 1.29 0 0 0-1.123-.654m.02 11.09a.5.5 0 0 1 0 1h-.011a.5.5 0 0 1 0-1zm-.011-5.599a.5.5 0 0 1 .5.5v3.778a.5.5 0 1 1-1 0v-3.778a.5.5 0 0 1 .5-.5"
  })));
};
export default SvgAlertTriangle;